export default __webpack_public_path__ + "static/media/allOn_en_d.a7f5c237.svg";